import React, { Component } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { func } from "prop-types";

import { selectors as i18nSelectors } from "reducers/i18n";
import { numberFormat, toNumber } from "util/number";

import ConnectedAmountField from "pages/_components/fields/AmountField";

class FormikAmountField extends Component {
    static propTypes = {
        inputHasChange: func,
    };

    static defaultProps = {
        inputHasChange: null,
    };

    handleBlur = () => {
        const { field, form, onBlurChange = null } = this.props;
        form.setFieldTouched(field.name);
        if (onBlurChange) {
            onBlurChange(form);
        }
    };

    handleCurrencyChange = ({ value }) => {
        const { field, form, onCurrencyChange } = this.props;
        if (onCurrencyChange) {
            onCurrencyChange(value);
        } else {
            form.setFieldValue(`${field.name}.currency`, value);
        }
    };

    handleInputChange = ({ target }) => {
        const { field, form, lang, onInputChange, allowNegative, precision, inputHasChange } = this.props;
        const { decimalSeparator } = numberFormat(lang);
        const number = toNumber(target.value, decimalSeparator, precision, allowNegative);
        if (onInputChange) {
            onInputChange(number);
        } else {
            form.setFieldValue(`${field.name}.amount`, number);
            if (form.errors[field.name]) {
                form.setErrors({
                    ...form.errors,
                    [field.name]: {
                        ...form.errors[field.name],
                    },
                });
            }
            if (inputHasChange) {
                inputHasChange(true);
            }
        }
    };

    render() {
        const { field, form, allowNegative } = this.props;
        return (
            <ConnectedAmountField
                {...field}
                hasError={form.touched[field.name] && form.errors[field.name]}
                onCurrencyChange={this.handleCurrencyChange}
                onInputChange={this.handleInputChange}
                onBlur={this.handleBlur}
                error={form.errors[field.name] && form.errors[field.name].amount}
                {...this.props}
                {...field.value}
            />
        );
    }
}

const mapStateToProps = (state) => ({
    lang: i18nSelectors.getLang(state),
});

export default compose(connect(mapStateToProps))(FormikAmountField);
